import { Dialog } from "primereact/dialog";
import "../MessagesList/MessagesList.css";
import formatSubjectWithLink from "../../utils/formatSubjectWithLink";

const MessageModal = ({ show, onClose, messagesDetails, colorObj }) => {
    return (
        <Dialog
            visible={show}
            onHide={() => show && onClose()}
            showHeader={false}
            className="mailingList"
            style={{ width: "50vw" }}
            breakpoints={{ "768px": "100vw" }}
            contentClassName="mailingList-content"
        >
            <div className="modal-header cursor-pointer mt-4" onClick={onClose}>
                <div className="closeIconMain ml-auto"></div>
            </div>

            <div className="col-md-12 py-4 px-2">
                <h3 className="title mb-4" style={{ color: colorObj?.accent_color1 }}>
                    {messagesDetails.sender}
                </h3>

                <hr
                    style={{
                        borderTop: `1px solid ${colorObj?.accent_color3}`,
                    }}
                />

                <div className="flex">
                    <div className="col-6">
                        <h3
                            className="titleText mb-3 mt-3"
                            style={{ color: colorObj?.accent_color1 }}
                        >
                            {messagesDetails.subject &&
                                formatSubjectWithLink(messagesDetails.subject)}
                        </h3>
                    </div>
                    <div className="col-6">
                        <h3 className="date mb-3 mt-3" style={{ color: colorObj?.accent_color1 }}>
                            {messagesDetails.message_date}
                        </h3>
                    </div>
                </div>

                <p className="mb-4 detail-message" style={{ color: colorObj?.accent_color1 }}>
                    {messagesDetails.message && formatSubjectWithLink(messagesDetails.message)}
                </p>
            </div>
        </Dialog>
    );
};

export default MessageModal;
